import PNRValidateForm from '../components/forms/pnr/pnr-validate-form';

const PNRValidate = () => {
    return (
        <PNRValidateForm></PNRValidateForm>
    )
  };
  
export default PNRValidate;
  